import type { ReactNode } from 'react'

import { useStepperConfig } from '../stepper/stepper-config.context'

import * as styles from './step-content.styles'

type Props = {
  children: ReactNode
  className?: string
}

export const StepContent = ({ children, className }: Props) => {
  const { variant } = useStepperConfig()

  return (
    <div
      className={className}
      css={[styles.container, styles.alignment[variant]]}
    >
      {children}
    </div>
  )
}
